import React from "react";
import { Grid2 } from "@mui/material";
import { FundamentalsCard } from "../FundamentalsCard";
import { DividendsByInvestmentChart } from "../DividendsChart/DividendsByInvestmentChart";
import { DetailInformationByInvestment } from "../DetailInformation/DetailInformation";
import { GainLossStatisticsLoader } from "../../../investment/details/GainLossStatisticsLoader";

export interface Props {
  investmentId: number;
  isInvestmentStock?: boolean;
  areDividendsPresent?: boolean;
}

export const SecurityFundamentalsByInvestmentId = ({
  investmentId,
  areDividendsPresent = false,
  isInvestmentStock = false,
}: Props) => (
  <Grid2 container spacing={4} width="100%" mt={5}>
    <FundamentalsCard>
      <GainLossStatisticsLoader investmentId={investmentId} />
    </FundamentalsCard>

    {isInvestmentStock && (
      <FundamentalsCard>
        <DetailInformationByInvestment investmentId={investmentId} />
      </FundamentalsCard>
    )}

    {areDividendsPresent && (
      <FundamentalsCard>
        <DividendsByInvestmentChart investmentId={investmentId} />
      </FundamentalsCard>
    )}
  </Grid2>
);
